import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { clearAuth } from '../../api/auth';
import { getTariffs, createPayment, getSubscription } from '../../api/vpn';
import './TariffsPage.css';

function TariffsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('buy');
  const [tariffs, setTariffs] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subLoading, setSubLoading] = useState(true);
  const [selectedTariff, setSelectedTariff] = useState(null);
  const [promoCode, setPromoCode] = useState('');
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    loadTariffs();
    loadSubscription();
  }, []);

  const loadTariffs = async () => {
    try {
      const data = await getTariffs();
      setTariffs(data);
    } catch (error) {
      console.error('Failed to load tariffs:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadSubscription = async () => {
    try {
      const data = await getSubscription();
      setSubscription(data);
    } catch (error) {
      console.error('Failed to load subscription:', error);
    } finally {
      setSubLoading(false);
    }
  };

  const handlePayment = async (tariffKey) => {
    setProcessing(true);
    setSelectedTariff(tariffKey);
    
    try {
      const payment = await createPayment(tariffKey, promoCode || null);
      
      // Если это пробный тариф, сервер возвращает success без confirmationUrl
      if (payment.success) {
        alert(payment.message || 'Пробный период активирован!');
        loadSubscription(); // Перезагружаем данные подписки
        setProcessing(false);
        setSelectedTariff(null);
      } else {
        window.location.href = payment.confirmationUrl;
      }
    } catch (error) {
      console.error('Payment error:', error);
      alert(error.message || 'Ошибка создания платежа. Попробуйте снова.');
      setProcessing(false);
      setSelectedTariff(null);
    }
  };

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="tariffs-page">
      <div className="tariffs-card">
        <div className="tariffs-header">
          <img src={logo} alt="VoidLink" className="tariffs-logo-img" />
          <h1 className="tariffs-logo">VoidLink</h1>
          <p className="tariffs-subtitle">VPN подписки</p>
        </div>

        <div className="tariffs-tabs">
          <button 
            className={`tariffs-tab ${activeTab === 'buy' ? 'active' : ''}`}
            onClick={() => setActiveTab('buy')}
          >
            Купить
          </button>
          <button 
            className={`tariffs-tab ${activeTab === 'subscription' ? 'active' : ''}`}
            onClick={() => setActiveTab('subscription')}
          >
            Моя подписка
          </button>
        </div>

        {activeTab === 'buy' && (
          <div className="tariffs-content">
            {loading ? (
              <p className="tariffs-loading">Загрузка тарифов...</p>
            ) : (
              <div className="tariffs-grid">
                {tariffs && Object.entries(tariffs).map(([key, tariff]) => (
                  <div key={key} className="tariff-card">
                    <h3 className="tariff-title">{tariff.title}</h3>
                    <div className="tariff-price">{tariff.price}₽</div>
                    <p className="tariff-description">{tariff.description}</p>
                    <button
                      className="tariff-button"
                      onClick={() => handlePayment(key)}
                      disabled={processing && selectedTariff === key}
                    >
                      {processing && selectedTariff === key ? 'Обработка...' : 'Купить'}
                    </button>
                  </div>
                ))}
              </div>
            )}

            <div className="promo-section">
              <label className="auth-field">
                <span>Промокод (опционально)</span>
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Введите промокод"
                  className="promo-input"
                />
              </label>
            </div>
          </div>
        )}

        {activeTab === 'subscription' && (
          <div className="tariffs-content">
            {subLoading ? (
              <p className="tariffs-loading">Загрузка подписки...</p>
            ) : subscription && subscription.active ? (
              <div className="subscription-active">
                <div className="subscription-status">
                  <span className="status-label">Статус:</span>
                  <span className="status-value active">Активна</span>
                </div>
                <div className="subscription-expire">
                  <span className="expire-label">Действует до:</span>
                  <span className="expire-value">
                    {subscription.expireDate ? new Date(subscription.expireDate).toLocaleDateString('ru-RU') : 'Неизвестно'}
                  </span>
                </div>
                {subscription.connectionLink && (
                  <div className="subscription-link">
                    <span className="link-label">Ссылка для подключения:</span>
                    <div className="link-input-group">
                      <input
                        type="text"
                        value={subscription.connectionLink}
                        readOnly
                        className="link-input"
                      />
                      <button 
                        className="copy-button"
                        onClick={() => handleCopy(subscription.connectionLink)}
                      >
                        Копировать
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="subscription-inactive">
                <p className="inactive-text">У вас нет активной подписки</p>
                <button 
                  className="tariff-button"
                  onClick={() => setActiveTab('buy')}
                >
                  Выбрать тариф
                </button>
              </div>
            )}
          </div>
        )}

        <button className="tariffs-logout" onClick={handleLogout}>
          Выйти
        </button>
      </div>
    </div>
  );
}

export default TariffsPage;
